var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"tag":"a","to":_vm.href}},[_c('div',{staticClass:"item",on:{"mouseenter":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}},[_c('i',{class:_vm.icon}),(_vm.hovered)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }